import { Drawer, Title } from '@mantine/core';
import { useMyForm } from '../../../../../../react-commons/hooks/useMyForm';
import {
    defaultRoleResource,
    RoleMutationResourceSchema,
    useRoleActions,
} from '../../../../resource/resources/artifacts/role/roleResource';
import { RoleContent } from '../../project/reusable-elements/role/RoleContent';

export const RoleDrawerContent = ({
    openedDrawer,
    closeDrawer,
    roleId,
}: {
    openedDrawer: boolean;
    closeDrawer: () => void;
    roleId: string | null;
}) => {
    const roleActions = useRoleActions();

    const roleQuery = roleActions.useGetResource(roleId);

    const { form, formNames } = useMyForm({
        schema: RoleMutationResourceSchema,
        defaultValues: defaultRoleResource,
        reactiveValues: roleQuery.data,
    });

    return (
        <Drawer
            opened={openedDrawer}
            onClose={closeDrawer}
            overlayProps={{ backgroundOpacity: 0.5, blur: 4 }}
            title={<Title order={3}>{roleQuery.data?.name}</Title>}
            position={'right'}
            size={'75%'}
            padding={25}
        >
            <RoleContent
                form={form}
                formNames={formNames}
                id={roleId ?? undefined}
                readOnly={true}
                displayedInOverview={true}
            />
        </Drawer>
    );
};
